/**
 * TanStack Query hooks for `igaming-deposit-tracking`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingDepositTrackingQueryKeys,
	type CreateIgamingDepositTrackingBody,
	type ListIgamingDepositTrackingResponse,
	type IgamingDepositTrackingRow,
} from "./api";

export function useIgamingDepositTrackingList(): UseQueryResult<ListIgamingDepositTrackingResponse, Error> {
	return useQuery({
		queryKey: igamingDepositTrackingQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingDepositTrackingCreate(): UseMutationResult<IgamingDepositTrackingRow, Error, CreateIgamingDepositTrackingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingDepositTrackingQueryKeys.all });
		},
	});
}

export function useIgamingDepositTrackingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingDepositTrackingQueryKeys.all });
		},
	});
}
